import axios from './providers/axios';
import {convertBooleanValuesToNumbers} from "@/utils/utils";

const notificationContentService = {

    getNotificationContent(page, filters = []) {
        let queryParams = `page=${page}&limit=20`;

        if (filters && filters.length > 0) {
            filters.forEach((filter) => {
                if (Array.isArray(filter.value)) {
                    filter.value.forEach((item, index) => {
                        Object.keys(item).forEach(key => {
                            queryParams += `&${filter.key}[${index}][${key}]=${item[key]}`;
                        });
                    });
                } else {
                    queryParams += `&${filter.key}=${filter.value}`;
                }
            });
        }

        return axios.get(`/v1/admin/notification/content/store?${queryParams}`);
    },

    getNotificationContentList(isTemplate=false, lang = 'tr') {
        let url = `/v1/admin/notification/content/store?list=true`;
        if (isTemplate===true){
            url += '&isTemplate=true';
        }
        return axios.get(url, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },
    getNotificationDetails(id, lang = 'tr') {
        return axios.get(`/v1/admin/notification/content/getFromId/${id}`, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },
    addNotificationContent(data, lang = 'tr') {
        data = convertBooleanValuesToNumbers(data);

        return axios.post(`/v1/admin/notification/content/add`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },
    updateNotificationContent(data, lang = 'tr') {
        data = convertBooleanValuesToNumbers(data);

        return axios.post(`/v1/admin/notification/content/update`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },

    sendNotification(userIds, notificationDataId, lang = 'tr') {
        const data = {
            userIds,
            notificationDataId
        };

        return axios.post(`/v1/app/notification/send`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': lang
            }
        });
    },

    getNotificationContentType(type) {
        return axios.get(`/v1/admin/notification/content/getByType/${type}`);
    },
    getLogs(lang, page = 1, limit = 20){
        return axios.get(`/v1/admin/notification/content/getLogs?page=${page}&limit=${limit}`, {
            headers:{
                "Accept-Language": lang,
            }
        });
    },
    getDetailLogs(lang,id){
        return axios.get(`/v1/admin/notification/content/getLogById/${id}`, {
            headers:{
                "Accept-Language": lang,
            }
        });
    }
}

export default notificationContentService;
